<img alt="user-photo" *ngIf="user?.photoUrl" class="p-1" src="{{user.photoUrl}}" [width]="size" [height]="size">
<div *ngIf="!user?.photoUrl" class="rounded-circle name-avatar p-1 m-auto" [ngStyle]="{ 'width': size + 'px', 'height': size + 'px', 'background-color': circleBackground, color: textColor}">
  <div class="name-avatar-text" [ngStyle]="{ fontSize, fontWeight }">{{ user?.firstname?.charAt(0) }}{{ user?.lastname?.charAt(0) }}</div>
</div>
